var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStoreIcon = function SvgStoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0v16H0V0h16ZM8.951 5.22H7.178v2.948H4.692v4.383h7.673a1.496 1.496 0 0 0 1.051-.437c.137-.137.246-.296.328-.478.082-.182.123-.378.123-.587V8.17H8.952v-.93h4.615V5.89H8.95v-.67Zm-.08-2.553h-1.79l.204.778h-4.79v7.686l-.63 1.392h1.899l.612-1.392V4.796h9.49V3.445H9.075l-.205-.778Zm3.098 6.84v1.269a.409.409 0 0 1-.123.3.409.409 0 0 1-.3.123H6.59V9.507h5.379Z",
    fill: "var(--primaryColor)",
    fillRule: "evenodd"
  })));
};

export default SvgStoreIcon;